import { actions } from '../../utils/constants';
import { deepMerge } from '../../utils/object-utils';

const DEFAULT_STATE = {
    student: {},
    classes: [],
    enrollments: [],
    tccLoading: false,
    pending: {},
    ttcProgresses: {},
    classesNewEad: [],
    loadingCourses: true,
    currentClasse: '',
    currentTccs: {},
    isSavingNewEad: false,
    disableRedirect: false,
    loadingOnlineTests: false,
    userId: null,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const newState = { ...state };
    const newStateStudent = newState.student;

    switch (type) {
        case actions.USER_ID_FETCHED:
            newState.userId = payload.id;
            return newState;

        case actions.ENROLLMENT_LIST_FETCHED:
            newState.enrollments = payload;
            return newState;

        case actions.TOGGLE_LOADING_COURSES:
            return { ...state, loadingCourses: payload };

        case actions.CLASS_FETCHED:
            let classes = [ ...newState.classes];
            const theClass = classes.find(c => c.classId === payload.classId);
            if (theClass) {
                deepMerge(theClass, payload);
            } else {
                classes.push(payload);
            }
            return { ...newState, classes: [...classes] };

        case actions.STUDENT_ENROLLMENT_FETCHED:
            newState.student = payload
                .map(enrollment => ({ [enrollment.classId]: { ...enrollment, classId: undefined, userId: undefined } }))
                .reduce((result, item) => ({ ...result, ...item }), {});
            return newState;

        case actions.STUDENT_ENROLLMENT_UPDATED:
            newStateStudent[payload.classId] = payload.value;
            return newState;

        case actions.LOADING_TCC_SUBMISSION:
            return { ...newState, ...payload };

        case actions.SET_LIST_CLASSES:
            return { ...newState, classesNewEad: payload.classes };

        case actions.SET_CURRENT_CLASSE:
            return { ...newState, currentClasse: payload };

        case actions.SET_CURRENT_TCCS:
            return { ...newState, currentTccs: payload };

        case actions.SET_IS_SAVING_NEW_EAD:
            return { ...newState, isSavingNewEad: payload };

        case actions.DISABLED_REDIRECT:
            return { ...newState, disableRedirect: payload };

        case actions.SET_LOADING_TESTS_ONLINE:
            return { ...newState, loadingOnlineTests: payload };

        case actions.CLEAN_CLASSES:
            return { ...newState, currentClasse: '' };

        case actions.STUDENT_ACTIVITY_UPDATED:
            newStateStudent[payload.classId] = { ...newStateStudent[payload.classId],
                activities: { ...newStateStudent[payload.classId].activities, ...payload.value } };
            return newState;

        case actions.UPDATE_ACTIVITY_STATUS:
            newState.pending[`${payload.classId}:${payload.id}`] = payload.pending;
            return newState;

        case actions.TCCS_PROGRESS_UPDATED:
            Object.keys(payload.progresses)
                .forEach(tccId => {
                    Object.assign(newState.ttcProgresses, { [`${payload.classId}:${tccId}`]: payload.progresses[tccId] });
                });
            return newState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/app/app.reducer.js